import { IntegrationFieldBuilder } from './integration-field-builder'
import { CustomFieldConfig } from '../integration-form-types/integration-field-config'
import { IntegrationFormField } from '../integration-form-types/integration-form-field'
import { SupportedFormFields } from '../integration-form-types/supported-form-field-types'

interface Customfield extends IntegrationFormField {
  config: CustomFieldConfig
}

export class CustomFieldBuilder extends IntegrationFieldBuilder {
  field: SupportedFormFields = 'custom'

  config: CustomFieldConfig = {
    placement: 1,
    customField: <div />,
  }

  placement(placement: number): this {
    this.config.placement = placement
    return this
  }

  isHidden(hidden: boolean | undefined): this {
    this.config.isHidden = hidden
    return this
  }

  customField(field: React.ReactNode): this {
    this.config.customField = field
    return this
  }

  build(): Customfield {
    const customfield: Customfield = {
      field: this.field,
      config: this.config,
    }

    return customfield
  }
}
